<template>
  <div id="inside" style="" :style="largura > 500 ? '' : 'min-height: 480px;'">
    <nav class="navbar3 navbar-light navbar-expand" v-if="!loadingBoot">
      <div class="container justify-content-center pt-0">
        <button
          class="navbar-toggler navbar-toggler-right border-0"
          type="button"
          data-toggle="collapse"
          data-target="#navbar3"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          class="collapse navbar-collapse text-center justify-content-center"
          id="navbar3"
        >
          <ul class="navbar-nav justify-content-between">
            <li class="nav-item border-bottom border-info mx-5 mb-2">
              <a class="nav-link active" @click="home" style="cursor: pointer"
                >Propostas</a
              >
            </li>
            <li class="nav-item mx-5">
              <a class="nav-link" @click="meusAcordos" style="cursor: pointer"
                >Acordos
                <span
                  class="badge badge-primary badge-pill"
                  v-if="agreements && agreements.length"
                  >{{ agreements.length }}</span
                >
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div v-bind:class="largura > 500 ? 'container' : ''">
      <div class="row d-flex justify-content-center px16 my16">
        <div class="px-0 col-lg-12">
          <div class="stepper-wrapper">
            <div class="stepper-item active">
              <div class="step-counter">1</div>
            </div>
            <div class="stepper-item">
              <div class="step-counter">2</div>
            </div>
            <div class="stepper-item">
              <div class="step-counter">3</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-12 mt-3" v-if="contract">
        <div class="row">
          <div class="col-lg-12">
            <h5 class="mb-1 text-primary" style="font-weight: bold">
              Olá, {{ user.FullName ? user.FullName : user.DocNumber }}!
            </h5>
            <h6 class="mb-0" style="color: #3a4148; font-weight: 600">
              Você está negociando o contrato {{ contract.contrato }}
            </h6>
            <p class="mb-0" style="color: #3a4148; font-weight: 400; font-style: italic">
              Selecione as parcelas, atualize os valores e escolha a forma de pagamento.
            </p>
          </div>
        </div>
      </div>

      <div class="container mt-3" v-if="contract">
        <div class="row">
          <div
            v-bind:class="
              largura > 500
                ? 'col-lg-4 col-md-6 col-12 mb-1'
                : 'col-lg-4 col-md-6 col-12 mb-1'
            "
          >
            <div class="card">
              <div class="card-body pb-3">
                <h6 style="font-weight: 600">
                  Contrato {{ contract.contrato }}
                </h6>
                <p class="mb-2 text-muted" style="font-size: 0.8rem">
                  Produto {{ contract.produto }}
                </p>

                <div
                  class="discount-highlight d-flex align-items-center justify-content-center"
                  v-if="hasRealDiscount(contract)"
                >
                  <span
                    class="melhor-oferta-badge mt-1"
                    style="text-transform: none !important; font-size: 12pt"
                  >
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 12 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style="margin-right: 5px; margin-bottom: 4px"
                    >
                      <path
                        d="M3.16172 6.41295C4.15428 4.93822 5.09363 3.53429 5.20824 1.7642C5.23484 1.35961 5.20005 0.950976 5.21438 0.546385C5.22052 0.360273 5.09568 0.101335 5.35354 0.0123249C5.54387 -0.0524096 5.66461 0.153932 5.78945 0.271263C7.14834 1.55179 8.44173 2.89099 9.54685 4.39809C10.8321 6.14997 11.8471 8.02727 11.9843 10.2303C12.1725 13.2283 10.6745 16.2384 7.38982 16.8838C3.29884 17.6889 -0.444237 14.1932 0.0428338 10.0785C0.255671 8.28621 0.904417 6.69617 1.96042 5.24976C2.07707 5.08994 2.17326 4.83505 2.39837 4.86944C2.63168 4.90383 2.6194 5.17693 2.68284 5.36506C2.7647 5.6058 2.8527 5.84248 2.94889 6.07714C2.98572 6.16615 3.05121 6.24303 3.16172 6.41295ZM5.92861 8.01513C5.94908 9.21879 5.57252 10.0442 5.04656 10.8109C4.9381 10.9686 4.78666 11.3409 4.5554 10.9808C4.1461 10.3415 4.03559 10.8473 3.86777 11.1204C3.55465 11.6261 3.37251 12.1885 3.31521 12.7711C3.19242 13.999 3.58331 15.0328 4.64954 15.7388C5.64005 16.3942 6.68582 16.4286 7.70089 15.8197C8.75894 15.1845 9.12732 14.1427 9.02704 13.0017C8.84694 10.9403 7.49215 9.54651 5.92861 8.01513Z"
                        fill="white"
                      />
                    </svg>&nbsp;
                    {{
                      isContractFullySelected(contract)
                        ? "Oferta para quitar este contrato"
                        : "Oferta para atualizar este contrato"
                    }}
                  </span>
                </div>

                <div class="contract-item mt-3">
                  <div class="contract-intern">
                    <label class="checkbox-container mb-0">
                      <input
                        type="checkbox"
                        :checked="isContractFullySelected(contract)"
                        @change="toggleContrato(contract, $event.target.checked)"
                        :disabled="loading"
                      />
                      <span class="checkmark"></span>
                      <span class="contract-text"
                        >Contrato {{ contract.contrato }}</span
                      >
                    </label>
                  </div>

                  <div
                    class="table-responsive"
                    :style="
                      (contract.parcelas || []).length > 4
                        ? 'max-height: 14rem; overflow-y: auto;'
                        : 'overflow-y: auto;'
                    "
                  >
                    <table class="table">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Parcela</th>
                          <th>Vencimento</th>
                          <th>Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(parc, k) in contract.parcelas" :key="k">
                          <td>
                            <input
                              type="checkbox"
                              class="checkmark"
                              style="cursor: pointer"
                              :disabled="!canToggleParcela(contract, k) || loading"
                              :checked="!!parc.selected"
                              @change="onToggleParcela(k)"
                            />
                          </td>
                          <td>{{ k + 1 }}/{{ contract.parcelas.length }}</td>
                          <td>
                            {{
                              formatData(
                                parc.vencimento,
                                "YYYY-MM-DD",
                                "DD/MM/YYYY"
                              )
                            }}
                          </td>
                          <td>{{ parc.valor }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <p class="mb-1 mt-3" style="font-style: italic; color: #3a4148">
                  Parcelas selecionadas:
                  <strong>{{ selectedCount(contract) }}</strong>
                  · Total
                  <strong>R$ {{ selectedTotal(contract) }}</strong>
                </p>

                <p class="text-info mb-1">Escolha o vencimento</p>
                <div class="form-group m-0 mx-0 p-0">
                  <div class="form-group">
                    <select
                      id="DiaSelect"
                      class="form-control"
                      v-model="dueDate"
                      :disabled="loading"
                      @change="markNeedUpdate()"
                    >
                      <option
                        v-for="(date, dateIndex) in dueDates"
                        :key="`date-${dateIndex}-${date}`"
                      >
                        {{ date }}
                      </option>
                    </select>
                  </div>
                </div>

                <button
                  :class="{
                    'alert-flashing': selectedCount(contract) > 0 && needUpdate,
                  }"
                  style="
                    width: 100%;
                    border-radius: 20px;
                    background-color: #e7ebfd;
                    padding: 10px;
                    margin-bottom: 10px;
                  "
                  :disabled="selectedCount(contract) <= 0 || loading"
                  @click="atualizarValores()"
                >
                  Atualizar valores
                </button>

                <ProgressLoading v-bind:loading="loading" />

                <template v-if="!needUpdate && !loading && hasOffersReady">
                  <button
                    class="btn btn-primary btn-block text-white"
                    @click="negociar(0)"
                    style="cursor: pointer !important"
                    :disabled="
                      needUpdate ||
                      selectedCount(contract) === 0 ||
                      !contract.atSightOffer
                    "
                  >
                    PAGAR À VISTA R$
                    {{ contract.atSightOffer }}
                  </button>

                  <div v-if="isContractFullySelected(contract)">
                    <p
                      class="mb-1 text-center mb-2 mt-3"
                      v-if="(contract.offers || []).length > 1"
                    >
                      Ou escolha uma das opções disponíveis
                    </p>
                    <div v-if="(contract.offers || []).length > 1">
                      <div
                        class="col-12 pr-1 pl-1"
                        v-for="(installment1, key3, index3) in contract.offers"
                        :key="`${key3}-${index3}`"
                      >
                        <div
                          class="preco-parcelado-box"
                          style="cursor: pointer"
                          v-if="installment1.INSTALLMENTnUMBER > 0"
                          @click="negociar(installment1)"
                        >
                          <span class="parcela-texto"
                            >Entrada +
                            {{ installment1.INSTALLMENTnUMBER }}x R$
                            {{ installment1.PARCELAS[0].PAGO }}</span
                          >
                          <div class="badge-desconto">
                            <i class="fa fa-arrow-down"></i>&nbsp;{{
                              calculateDiscountPercentage(installment1)
                            }}%
                          </div>
                          <div class="badge-seta">
                            <i class="fa fa-arrow-right"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="text-center mt-1"
                      v-if="(contract.offers || []).length > 1"
                    >
                      <button
                        type="button"
                        class="linklike"
                        :disabled="loading || !canShowMore"
                        @click="showMoreOptions()"
                      >
                        Mostrar mais opções
                      </button>
                    </div>
                  </div>
                </template>

                <a
                  @click="voltar"
                  class="d-block text-center mt-4"
                  style="
                    text-decoration: underline;
                    color: #03659b;
                    cursor: pointer;
                  "
                  >Voltar</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-4" v-if="!contract && !loadingBoot">
        <div
          class="mb-0 mt-4 text-center p-5"
          style="
            color: #3a4148;
            font-weight: 400;
            font-style: italic;
            background-color: #fff;
            border-radius: 10px;
          "
        >
          Contrato não encontrado para negociação.
          <a
            @click="voltar"
            class="d-block text-center mt-3"
            style="
              text-decoration: underline;
              color: #03659b;
              cursor: pointer;
            "
            >Voltar ao dashboard</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatData, parseBR } from "@/utils/helpers";
import ProgressLoading from "../../../modules/auth/components/ProgressLoading.vue";

export default {
  name: "propostas-tribanco",
  components: { ProgressLoading },
  data() {
    return {
      contract: null,
      dueDate: null,
      dueDates: [],
      largura: typeof window !== "undefined" ? window.screen.width : 1024,
      loading: false,
      loadingBoot: true,
      needUpdate: false,
      optionsInstallments: [0, 2, 5, 8],
      userAdm: null,
      ipUser: "",
      hasOffersReady: false,
      agreements: [],
      currentPage: "propostasTribanco",
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    canShowMore() {
      const max = this.contract?.maxInstallmentNumber ?? 24;
      const last = Math.max(...(this.optionsInstallments || [0]));
      return last < max - 1;
    },
  },
  created() {
    this.largura = window.screen.width;
    this.ipUser = localStorage.getItem("ipUser") ?? "";
    try {
      this.userAdm = JSON.parse(localStorage.getItem("userAdm") || "null");
    } catch {
      this.userAdm = null;
    }

    try {
      const agreements = localStorage.getItem("agreements");
      this.agreements = agreements ? JSON.parse(agreements) : [];
    } catch {
      this.agreements = [];
    }

    try {
      const raw = localStorage.getItem("propostaTribancoContract");
      this.contract = raw ? JSON.parse(raw) : null;
    } catch {
      this.contract = null;
    }

    const contractId = this.$route.params.contractId;
    if (
      contractId &&
      (!this.contract || String(this.contract.contrato) !== String(contractId))
    ) {
      try {
        const list = JSON.parse(localStorage.getItem("contracts") || "[]");
        const found = (Array.isArray(list) ? list : []).find(
          (c) => String(c && c.contrato) === String(contractId)
        );
        if (found) this.contract = found;
      } catch {
        /* o contrato gravado na navegação continua valendo */
      }
    }

    try {
      const dates = JSON.parse(
        localStorage.getItem("propostaTribancoDueDates") || "[]"
      );
      this.dueDates = Array.isArray(dates) ? dates : [];
    } catch {
      this.dueDates = [];
    }

    this.dueDate =
      localStorage.getItem("propostaTribancoDueDate") || this.dueDates[0] || null;

    if (this.contract) {
      (this.contract.parcelas || []).forEach((p, i) => {
        if (!("selected" in p)) this.$set(p, "selected", false);
        else this.$set(this.contract.parcelas[i], "selected", !!p.selected);
      });
      if (!Array.isArray(this.contract.offers)) this.$set(this.contract, "offers", []);
      this.normalizeSelection(this.contract);
      this.needUpdate = this.selectedCount(this.contract) > 0;
      this.hasOffersReady = false;
    }

    this.loadingBoot = false;
  },
  methods: {
    formatData,
    parseBR,
    ...mapActions("minhasDividas", ["ActionGetOffersTribanco"]),

    home() {
      localStorage.setItem("currentPage", "dashboard");
      this.$router.push({ name: "dashboard" });
    },

    meusAcordos() {
      localStorage.setItem("currentPage", "meusAcordos");
      this.$router.push({ name: "meusAcordos" });
    },

    voltar() {
      this.$router.push({ name: "dashboard" });
    },

    showError(message) {
      this.flashMessage.show({
        timeout: 1500,
        status: "error",
        blockClass: "custom-block-class",
        title: "Ocorreu um erro",
        message,
      });
    },

    markNeedUpdate() {
      this.needUpdate = true;
      this.hasOffersReady = false;
    },

    onToggleParcela(idx) {
      this.toggleParcela(this.contract, idx);
      this.markNeedUpdate();
    },

    toISO(dateStr) {
      if (!dateStr) return null;
      if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) return String(dateStr).slice(0, 10);
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
        const [dd, mm, yyyy] = dateStr.split("/");
        return `${yyyy}-${mm}-${dd}`;
      }
      const d = new Date(dateStr);
      if (Number.isNaN(+d)) return null;
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },

    setParcelSelected(contract, i, val) {
      const parc = contract.parcelas[i];
      if (!("selected" in parc)) this.$set(parc, "selected", !!val);
      else parc.selected = !!val;
    },

    lastSelectableIndex(contract) {
      const i = (contract.parcelas || []).findIndex((p) => p?.selectable === false);
      return (i === -1 ? (contract.parcelas || []).length : i) - 1;
    },

    parcelDueISO(parc) {
      return this.toISO(parc?.vencimento);
    },

    todayISO() {
      const d = new Date();
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
      ).padStart(2, "0")}`;
    },

    isOverdueOrCurrent(parc) {
      const iso = this.parcelDueISO(parc);
      return !!(iso && iso <= this.todayISO());
    },

    requiredPrefixIndex(contract) {
      const lastIdx = this.lastSelectableIndex(contract);
      for (let i = 0; i <= lastIdx; i++) {
        if (this.isOverdueOrCurrent(contract.parcelas?.[i])) return i;
      }
      return -1;
    },

    lastSelectedIndex(contract) {
      const lastIdx = this.lastSelectableIndex(contract);
      let k = -1;
      for (let i = 0; i <= lastIdx; i++) {
        if (contract.parcelas?.[i]?.selected) k = i;
        else break;
      }
      return k;
    },

    canToggleParcela(contract, idx) {
      const lastIdx = this.lastSelectableIndex(contract);
      const parc = contract.parcelas?.[idx];
      if (idx < 0 || idx > lastIdx || !parc || parc.selectable === false) return false;

      const lastSelected = this.lastSelectedIndex(contract);
      const required = this.requiredPrefixIndex(contract);

      if (parc.selected) return idx === lastSelected && idx > required;
      return idx === lastSelected + 1;
    },

    normalizeSelection(contract) {
      const lastIdx = this.lastSelectableIndex(contract);
      const required = this.requiredPrefixIndex(contract);
      let k = -1;
      for (let i = 0; i <= lastIdx; i++) {
        if (contract.parcelas[i].selected) k = i;
        else break;
      }
      if (k < required) k = required;
      for (let i = 0; i <= lastIdx; i++) this.setParcelSelected(contract, i, i <= k);
      for (let i = lastIdx + 1; i < (contract.parcelas || []).length; i++)
        this.setParcelSelected(contract, i, false);
    },

    toggleContrato(contract, checked) {
      const lastIdx = this.lastSelectableIndex(contract);
      const required = this.requiredPrefixIndex(contract);
      const maxIdx = checked ? lastIdx : required;
      for (let i = 0; i < (contract.parcelas || []).length; i++) {
        const can = i <= lastIdx && contract.parcelas[i]?.selectable !== false;
        this.setParcelSelected(contract, i, can && i <= maxIdx);
      }
      this.normalizeSelection(contract);
      this.markNeedUpdate();
    },

    toggleParcela(contract, idx) {
      if (!this.canToggleParcela(contract, idx)) {
        this.normalizeSelection(contract);
        return;
      }
      const lastIdx = this.lastSelectableIndex(contract);
      const target = contract.parcelas[idx];
      if (!target.selected) {
        for (let i = 0; i <= idx; i++) {
          if (contract.parcelas[i]?.selectable === false) break;
          this.setParcelSelected(contract, i, true);
        }
      } else {
        for (let i = idx; i <= lastIdx; i++) this.setParcelSelected(contract, i, false);
      }
      this.normalizeSelection(contract);
    },

    selectedCount(contract) {
      return (contract.parcelas || []).filter((p) => !!p.selected).length;
    },

    selectedTotal(contract) {
      const sum = (contract.parcelas || [])
        .filter((p) => !!p.selected)
        .reduce((acc, p) => acc + parseBR(p.valor), 0);
      return sum.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    isContractFullySelected(contract) {
      const lastIdx = this.lastSelectableIndex(contract);
      if (!contract?.parcelas || lastIdx < 0) return false;
      return contract.parcelas
        .slice(0, lastIdx + 1)
        .every((p) => p && p.selectable !== false && !!p.selected);
    },

    hasRealDiscount(contract) {
      if (!contract) return false;
      const from = parseBR(contract.offers?.[0]?.RETORNO?.VALORPARCELAR);
      const to = parseBR(
        contract.atSightOffer ?? contract.offers?.[0]?.RETORNO?.VALORTOTAL
      );
      if (from > 0 && to > 0 && from > to) return true;
      if (parseBR(contract.discountPercentage) > 0) return true;
      if (
        parseBR(
          contract.discountValue ?? contract.offers?.[0]?.RETORNO?.DESCONTO
        ) > 0
      ) {
        return true;
      }
      return false;
    },

    calculateDiscountPercentage(installment) {
      try {
        return (
          ((parseFloat(
            installment.RETORNO.VALORPARCELAR.replace(/\./g, "").replace(",", ".")
          ) -
            parseFloat(
              installment.RETORNO.VALORTOTAL.replace(/\./g, "").replace(",", ".")
            )) /
            parseFloat(
              installment.RETORNO.VALORPARCELAR.replace(/\./g, "").replace(",", ".")
            )) *
          100
        ).toFixed(2);
      } catch {
        return "0.00";
      }
    },

    async atualizarValores() {
      if (!this.contract) return;
      const idxs = (this.contract.parcelas || [])
        .map((p, i) => (p && p.selected ? i : -1))
        .filter((i) => i >= 0);

      if (!idxs.length) {
        this.showError("Selecione ao menos uma parcela para atualizar.");
        return;
      }

      const installments = idxs
        .map((i) => ({
          contract: this.contract.contrato,
          product: this.contract.produto,
          dueInstallmentDate: this.toISO(this.contract.parcelas[i]?.vencimento),
        }))
        .filter((i) => !!i.dueInstallmentDate);

      if (!installments.length) {
        this.showError("Parcela selecionada sem data de vencimento válida.");
        return;
      }

      this.loading = true;
      try {
        const dueDateISO = this.toISO(this.dueDate);
        const fullySelected = this.isContractFullySelected(this.contract);

        const resp = await this.ActionGetOffersTribanco({
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          document: String(this.contract.regis),
          regis: String(this.contract.regis),
          credor: this.contract.credor,
          company: this.contract.company,
          contract: this.contract.contrato,
          product: this.contract.produto,
          dueDate: dueDateISO || this.dueDate,
          inputValue: "0",
          options: fullySelected ? this.optionsInstallments : [0],
          installments,
          tag: localStorage.getItem("tag"),
          OS: navigator.platform,
          IP: this.ipUser || "",
        });

        const data =
          resp && (resp.offers !== undefined || resp.atSightOffer !== undefined)
            ? resp
            : null;

        if (data) {
          if (Array.isArray(data.offers) && data.offers.length > 0) {
            this.$set(this.contract, "offers", data.offers);
          }
          if (data.atSightOffer !== undefined && data.atSightOffer !== null) {
            this.$set(this.contract, "atSightOffer", data.atSightOffer);
          }
          if (data.discountValue !== undefined) {
            this.$set(this.contract, "discountValue", data.discountValue);
          }
          if (data.discountPercentage !== undefined) {
            this.$set(this.contract, "discountPercentage", data.discountPercentage);
          }
        }

        this.needUpdate = false;
        this.hasOffersReady = !!(
          this.contract.atSightOffer || (this.contract.offers || []).length
        );
        localStorage.setItem(
          "propostaTribancoContract",
          JSON.stringify(this.contract)
        );
      } catch (e) {
        this.showError(e?.data?.message || e?.message || "Falha ao atualizar ofertas.");
      } finally {
        this.loading = false;
      }
    },

    async showMoreOptions() {
      if (!this.canShowMore) return;
      const maxIndex = (this.contract?.maxInstallmentNumber ?? 24) - 1;
      const base = Math.max(
        8,
        ...this.optionsInstallments.filter((n) => n >= 8)
      );
      const start = base + 1;
      const toAdd = [];
      for (let i = 0; i < 3 && start + i <= maxIndex; i++) toAdd.push(start + i);
      this.optionsInstallments = [
        ...new Set([...this.optionsInstallments, ...toAdd]),
      ].sort((a, b) => a - b);
      this.markNeedUpdate();
      await this.atualizarValores();
    },

    negociar(installment) {
      if (this.needUpdate) {
        this.showError("Atualize os valores antes de continuar.");
        return;
      }
      if (this.selectedCount(this.contract) === 0) {
        this.showError("Selecione ao menos uma parcela.");
        return;
      }

      const installmentNumber =
        installment === 0 ? 0 : installment.INSTALLMENTnUMBER;

      let discountPerc = null;
      if (installmentNumber === 0) {
        discountPerc = this.contract.discountPercentage;
      } else {
        discountPerc = this.calculateDiscountPercentage(installment);
      }

      const idxs = (this.contract.parcelas || [])
        .map((p, i) => (p?.selected ? i : -1))
        .filter((i) => i >= 0);

      const installments = idxs.map((i) => ({
        contract: this.contract.contrato,
        product: this.contract.produto,
        dueInstallmentDate: this.toISO(this.contract.parcelas[i]?.vencimento),
      }));

      const firstIdx = idxs[0];
      const lastIdx = idxs[idxs.length - 1];
      const offer0 = Array.isArray(this.contract.offers)
        ? this.contract.offers[0]
        : null;
      const ret = offer0?.RETORNO || {};

      const selectedSum = idxs.reduce(
        (acc, i) => acc + parseBR(this.contract.parcelas[i]?.valor),
        0
      );
      const selectedSumFormatted = selectedSum.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      const due = this.toISO(this.dueDate);
      const payload = {
        document: String(this.contract.regis),
        credor: this.contract.credor,
        company: this.contract.company,
        inputValue:
          installmentNumber === 0
            ? "0"
            : String(installment.PARCELAS[0].PAGO),
        installmentNumber: String(installmentNumber),
        installments,
        dueDate: due,
        source: 1,
        contracts: [
          {
            contract: this.contract.contrato,
            startInstallmentNumber: firstIdx + 1,
            endInstallmentNumber: lastIdx + 1,
            totalInstallments: idxs.length,
            startDueInstallmentDate: this.toISO(
              this.contract.parcelas[firstIdx]?.vencimento
            ),
            endDueInstallmentDate: this.toISO(
              this.contract.parcelas[lastIdx]?.vencimento
            ),
            originalValue:
              ret.PRINCIPAL ?? this.contract.originalValue ?? selectedSumFormatted,
            updatedValue:
              ret.VALORTOTAL ?? this.contract.atSightOffer ?? selectedSumFormatted,
            discountValue: ret.DESCONTO ?? this.contract.discountValue ?? "0,00",
            expenseValue:
              ret.VALORPARCELAR ?? this.contract.updatedValue ?? selectedSumFormatted,
            discountPercentage:
              discountPerc === null || discountPerc === undefined
                ? this.contract.discountPercentage ?? "0"
                : String(discountPerc),
            inCash: String(installmentNumber) === "0",
            dueDate: due,
          },
        ],
      };

      localStorage.setItem("agreementPayload", JSON.stringify(payload));
      this.$router.push({ name: "resumoAcordoTribanco" });
    },
  },
};
</script>

<style scoped>
.alert-flashing {
  animation: alert-flash 0.5s infinite alternate;
  width: 100%;
}

@keyframes alert-flash {
  0% {
    background-color: #e7ebfd;
    color: #0046c0;
  }
  100% {
    background-color: #a2b1d8;
  }
}

.linklike {
  background: none;
  border: 0;
  padding: 0;
  color: #0d6efd;
  text-decoration: underline;
  cursor: pointer;
}

.linklike:disabled {
  color: #6c757d;
  text-decoration: none;
  cursor: not-allowed;
}
</style>
